// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__zXDmQ","options":"AnswerScale_options__3LuXB","selected":"AnswerScale_selected__zoGVl"};